import ActionsList from 'cancellations/components/search/actions';
import { CancellationDueDeathSearchCrumbs } from 'cancellations/constants/cancellation-due-death-crumbs';
import { Fragment } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import PersonSearch from 'shell/components/shared/person-search';
import { __PERSON_NEW_API_URL__ } from 'shell/constants/environment';

const CancellationDueDeathSearchPersonPage = (): React.ReactElement => {
  return (
    <Fragment>
      <Breadcrumbs items={CancellationDueDeathSearchCrumbs} />
      <PersonSearch
        pathname="/cancellazioni/cancellazione-per-morte/cancellazione"
        action={ActionsList}
        addedTitle="- Cancellazione per morte"
        url={`${__PERSON_NEW_API_URL__}/ricerca-persona/cancellazione-morte`}
      />
    </Fragment>
  );
};

CancellationDueDeathSearchPersonPage.displayName =
  'Cancellation id card search person page component';

export default CancellationDueDeathSearchPersonPage;
